import React from "react";
import { EmployeesViewProps } from "../types";
import { EmployeesTable } from "../EmployeesTable";
import "../EmployeesPage.css";

export const EmployeesView: React.FC<EmployeesViewProps> = ({
  employees,
  loading,
  error,
}) => {
  if (loading) {
    return (
      <div className="employees-page">
        <div className="employees-page-header">
          <h1>Employees</h1>
        </div>
        <div className="employees-page-loading">Loading employees...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="employees-page">
        <div className="employees-page-header">
          <h1>Employees</h1>
        </div>
        <div className="employees-page-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="employees-page">
      <div className="employees-page-header">
        <h1>Employees</h1>
        <div className="employees-page-stats">
          {employees.length} employee{employees.length !== 1 ? "s" : ""}
        </div>
      </div>
      <div className="employees-page-content">
        <EmployeesTable employees={employees} />
      </div>
    </div>
  );
};